import { render, staticRenderFns } from "./Tos.vue?vue&type=template&id=2f084fcc&scoped=true&"
import script from "./Tos.vue?vue&type=script&lang=js&"
export * from "./Tos.vue?vue&type=script&lang=js&"
import style0 from "./Tos.vue?vue&type=style&index=0&id=2f084fcc&lang=stylus&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2f084fcc",
  null
  
)

export default component.exports